// extracted by mini-css-extract-plugin
export default {"indicator":"Tabs_indicator__Vd-hI","root":"Tabs_root__XPlNK","borderLeft":"Tabs_borderLeft__zd5o8","borderRight":"Tabs_borderRight__Cf7ST"};